import { useCallback, useEffect, useRef } from 'react';

/**
 * You can pass in a function to get run, or use the returned
 * single use function.
 */
export const useOnFirstRenderOnly = (callbackArg?: () => void) => {
  const hasRun = useRef(false);

  const singleUseFunction = useCallback((callback: () => void) => {
    if (!hasRun.current) {
      callback();
      hasRun.current = true;
    }
  }, []);

  useEffect(() => {
    if (callbackArg) {
      singleUseFunction(callbackArg);
    }
  }, [callbackArg, singleUseFunction]);

  return callbackArg ? undefined : singleUseFunction;
};
